module.exports = __webpack_public_path__ + "img/pd-img42.9d27ffc0.jpg";